import { useState, useEffect, useCallback } from "react";
import { isMobileDevice } from "../utils/isMobileDevice";

/**
 * Captura beforeinstallprompt solo en dispositivos móviles (no escritorio).
 */
export function usePWAInstall() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [outcome, setOutcome] = useState(null);

  useEffect(() => {
    if (!isMobileDevice()) return undefined;

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener("beforeinstallprompt", onBeforeInstall);
    return () =>
      window.removeEventListener("beforeinstallprompt", onBeforeInstall);
  }, []);

  const install = useCallback(async () => {
    if (!deferredPrompt) return false;
    deferredPrompt.prompt();
    const choice = await deferredPrompt.userChoice;
    setOutcome(choice.outcome);
    setDeferredPrompt(null);
    return choice.outcome === "accepted";
  }, [deferredPrompt]);

  return {
    canInstall: Boolean(deferredPrompt),
    install,
    outcome,
    isMobile: isMobileDevice(),
  };
}
